import {userData} from "../js/stores";
import {addAlert} from "../js/alert";


/** @return Returns ***true*** if login validity expires */
export default function checkLoginValidity(status) {
    if (status === 401) {
        userData.set(null)
        addAlert("danger", "Chyba", "Platnosť vášho prihlásenia vypršala. Prosíme prihláste sa znova.")
        return true
    }
    return false
}